/**
 * AdminButton - [Phase 2a.2-C §5.1]
 *
 * Mirrors ProfileButton's pill style. Appears in the same 3 headers
 * (Dashboard, DraftRoom, SeasonShell) alongside ProfileButton.
 *
 * Renders ONLY when user.role === 'admin'. Clicking navigates to /admin.
 */
import { useNavigate } from "react-router-dom";
import { Shield } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export default function AdminButton({ variant = "dark" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  if (!user || user.role !== "admin") return null;

  const isLight = variant === "light";
  const btnBg = isLight
    ? "bg-[#FF6B00]/10 hover:bg-[#FF6B00]/20 border-[#FF6B00]/40"
    : "bg-[#FF6B00]/15 hover:bg-[#FF6B00]/25 border-[#FF6B00]/50";
  const btnText = "text-[#FF6B00]";

  return (
    <button
      data-testid="admin-btn"
      onClick={() => nav("/admin")}
      className={`flex items-center gap-1.5 ${btnBg} ${btnText} border font-display font-bold uppercase text-xs px-3 py-1.5 rounded-full transition-all`}
      title="Admin Dashboard"
    >
      <Shield size={12} />
      <span className="hidden sm:inline">Admin</span>
    </button>
  );
}
